<template>
	<div class="card shadow-sm">
		<div class="card-body pd-x-20 pd-b-10">
			<div class="justify-content-center align-content-center">
				<process-component :type="requestCancelled ? 'error' : 'success'"></process-component>
			</div>
			<h4 class="card-title text-center">{{ type | toStartCase }} Request {{ requestCancelled ? 'Cancelled' : 'Submitted' }} Successfully</h4>
			<p class="card-text text-center">
				{{
					isMtnMobileMoney
						? 'We have sent you a USSD prompt, please approve the request. An email will be sent to you upon approval.'
						: `We have received your ${type} instruction. An email has been sent to you.`
				}}
			</p>
			<div class="text-center mg-b-25">
				<p class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 tx-medium mg-b-5">{{ type | toStartCase }} Amount</p>
				<h3 class="tx-26 tx-normal tx-rubik tx-spacing--2 mg-b-5">
					<small class="text-muted tx-light">{{ request.currency }}</small> {{ request.amount | toNumber }}
				</h3>
			</div>
			<div class="d-flex align-items-center justify-content-between mg-b-10">
				<p class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 tx-medium mg-b-0">Request Details</p>
				<a @click.prevent="showRequestDetails = !showRequestDetails" href="#show-request-details" class="tx-11 tx-medium mg-b-0">
					{{ showRequestDetails ? 'Hide' : 'Show' }}
				</a>
			</div>
			<ul v-if="showRequestDetails" class="list-group list-group-flush mg-b-0 tx-13">
				<li v-if="type === 'withdrawal'" class="list-group-item pd-x-0 d-flex justify-content-between">
					<span class="tx-medium">Asset</span>
					<span class="tx-rubik">{{ request.holding.security_details.name }}</span>
				</li>
				<li v-if="request.units" class="list-group-item pd-x-0 d-flex justify-content-between">
					<span class="tx-medium">Units</span>
					<span class="tx-rubik">{{ request.units }}</span>
				</li>
				<template v-if="type === 'withdrawal'">
					<li class="list-group-item pd-x-0 d-flex justify-content-between">
						<span class="tx-medium tx-color-03">Payment Account details</span>
					</li>
					<li class="list-group-item pd-x-0 d-flex justify-content-between">
						<span class="tx-medium">Bank Name</span>
						<span class="tx-rubik">{{ request.paymentAccount.bank_details.name }}</span>
					</li>
					<li class="list-group-item pd-x-0 d-flex justify-content-between">
						<span class="tx-medium">Branch</span>
						<span class="tx-rubik">{{ request.paymentAccount.branch_details.name }}</span>
					</li>
					<li class="list-group-item pd-x-0 d-flex justify-content-between">
						<span class="tx-medium">Account Number</span>
						<span class="tx-rubik">{{ request.paymentAccount.account_number }}</span>
					</li>
				</template>
				<template v-if="type === 'deposit' || type === 'investment'">
					<li class="list-group-item pd-x-0 d-flex justify-content-between">
						<span class="tx-medium tx-color-03">Deposit details</span>
					</li>
					<li class="list-group-item pd-x-0 d-flex justify-content-between">
						<span class="tx-medium">Amount</span>
						<span class="tx-rubik tx-semibold">{{ request.amount | toCurrency(request.currency) }}</span>
					</li>
					<li class="list-group-item pd-x-0 d-flex justify-content-between">
						<span class="tx-medium">Transaction Charges</span>
						<span class="tx-rubik tx-semibold">{{ request.charges | toCurrency(request.currency) }}</span>
					</li>
					<li class="list-group-item pd-x-0 d-flex justify-content-between">
						<span class="tx-medium">Total</span>
						<span class="tx-rubik tx-semibold">{{ request.total_units | toCurrency(request.currency) }}</span>
					</li>
					<li class="list-group-item pd-x-0 d-flex justify-content-between">
						<span class="tx-medium">Funding Channel</span>
						<span class="tx-rubik tx-semibold">{{ request.funding_channel | toStartCase }}</span>
					</li>
					<li class="list-group-item pd-x-0 d-flex justify-content-between">
						<span class="tx-medium">Reference</span>
						<span class="tx-rubik tx-semibold">{{ request.reference }}</span>
					</li>
				</template>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			showRequestDetails: true,
		};
	},
	computed: {
		isMtnMobileMoney() {
			const { funding_channel } = this.request;

			return _.toLower(funding_channel) === 'mtn_mobile_money';
		},
	},
	props: ['request', 'type', 'request-cancelled'],
};
</script>

<style>
</style>
